import React from 'react'
import PropTypes from 'prop-types'

const CodeForkIcon = ({ className, title }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    role="img"
    aria-label={title}
  >
    <path
      transform="translate(1.6666667 0)"
      d="M16.6667 3C16.6667 1.346 15.2646 0 13.5417 0C11.8187 0 10.4167 1.346 10.4167 3C10.4167
        4.302 11.2906 5.402 12.5 5.816V8C12.5 8.551 12.0333 9 11.4583 9H5.20833C4.63333 9 4.16667
        8.551 4.16667 8V5.816C5.37604 5.402 6.25 4.302 6.25 3C6.25 1.346 4.84792 0 3.125 0C1.40208
        0 0 1.346 0 3C0 4.302 0.873958 5.402 2.08333 5.816V8C2.08333 9.654 3.48542 11 5.20833
        11H7.29167V14.184C6.08229 14.598 5.20833 15.698 5.20833 17C5.20833 18.654 6.61042 20 8.33333
        20C10.0562 20 11.4583 18.654 11.4583 17C11.4583 15.698 10.5844 14.598 9.375 14.184V11H11.4583C13.1812
        11 14.5833 9.654 14.5833 8V5.816C15.7927 5.402 16.6667 4.302 16.6667 3ZM3.125 2C3.7 2 4.16667
        2.449 4.16667 3C4.16667 3.551 3.7 4 3.125 4C2.55 4 2.08333 3.551 2.08333 3C2.08333 2.449 2.55
        2 3.125 2ZM8.33333 18C7.75833 18 7.29167 17.552 7.29167 17C7.29167 16.448 7.75833 16 8.33333
        16C8.90833 16 9.375 16.448 9.375 17C9.375 17.552 8.90833 18 8.33333 18ZM13.5417 4C12.9667 4
        12.5 3.551 12.5 3C12.5 2.449 12.9667 2 13.5417 2C14.1167 2 14.5833 2.449 14.5833 3C14.5833
        3.551 14.1167 4 13.5417 4Z"
      fill="currentColor"
    />
  </svg>
)

CodeForkIcon.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string
}

CodeForkIcon.defaultProps = {
  className: '',
  title: ''
}

export default CodeForkIcon
